import React from 'react';
import { ChevronDownIcon, CheckIcon } from '@heroicons/react/24/outline';
import { Listbox, Transition } from '@headlessui/react';
import { Fragment } from 'react';

const EmailAccountSelector = ({ accounts, selectedAccount, onSelect, loading }) => {
  if (loading) {
    return (
      <div className="w-64 h-10 bg-gray-100 rounded-lg animate-pulse"></div>
    );
  }

  if (!accounts || accounts.length === 0) {
    return (
      <div className="text-sm text-gray-500">No email accounts configured</div>
    );
  }

  return (
    <Listbox value={selectedAccount} onChange={onSelect}>
      <div className="relative w-64">
        <Listbox.Button className="relative w-full cursor-pointer rounded-lg bg-white py-2 pl-3 pr-10 text-left border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 sm:text-sm">
          <span className="block truncate">
            {selectedAccount?.name || selectedAccount?.emailAddress || 'Select account'}
          </span>
          {selectedAccount && (
            <span className="block truncate text-xs text-gray-500">
              {selectedAccount.emailAddress}
            </span>
          )}
          <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
            <ChevronDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
          </span>
        </Listbox.Button>
        <Transition
          as={Fragment}
          leave="transition ease-in duration-100"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <Listbox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
            {accounts.map((account) => (
              <Listbox.Option
                key={account.id}
                className={({ active }) =>
                  `relative cursor-pointer select-none py-2 pl-10 pr-4 ${
                    active ? 'bg-blue-50 text-blue-900' : 'text-gray-900'
                  }`
                }
                value={account}
              >
                {({ selected }) => (
                  <>
                    <div>
                      <span className={`block truncate ${selected ? 'font-medium' : 'font-normal'}`}>
                        {account.name}
                      </span>
                      <span className="block truncate text-xs text-gray-500">
                        {account.emailAddress}
                      </span>
                    </div>
                    {selected && (
                      <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-blue-600">
                        <CheckIcon className="h-5 w-5" aria-hidden="true" />
                      </span>
                    )}
                  </>
                )}
              </Listbox.Option>
            ))}
          </Listbox.Options>
        </Transition>
      </div>
    </Listbox>
  );
};

export default EmailAccountSelector;

